import React from 'react';
import Loader from 'react-loader-spinner';
import { connect } from 'react-redux';
import './styles.css';


const loader = ({ loader }) => {

  if (loader.loading) {

    return (
      <div className="loader">
        <div className="loader-content" >
          <Loader
            type="Oval"
            color="#d44700"
            height="100"
            width="100"
          />
        </div>
      </div>
    );
  }
  else{
    return null;
  }
}

const mapStateToProps = state => ({
  loader: state.loader
});

export default connect(mapStateToProps)(loader);


// WEBPACK FOOTER //
// ./src/components/Loader/index.js